import { useEffect, useState } from "react";

/**
 * Reliable scroll progress (0..1) for an element across the viewport,
 * equivalent to framer offset ["start start", "end end"].
 * Uses window scroll + rAF (works with Lenis) and avoids framer-motion's
 * scroll-container ancestor detection issues.
 */
export default function useScrollProgress(ref) {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    let raf = 0;
    const calc = () => {
      const el = ref.current;
      if (!el) return;
      const total = el.offsetHeight - window.innerHeight;
      const scrolled = -el.getBoundingClientRect().top;
      const p = total > 0 ? Math.max(0, Math.min(1, scrolled / total)) : 0;
      setProgress(p);
    };
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(calc);
    };
    calc();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      cancelAnimationFrame(raf);
    };
  }, [ref]);
  return progress;
}
